
export interface IGetSuggestTimeRequest {
  organizer: string;
  meetingStartTime: string;
  meetingEndTime: string;
  attendees: string[];
  resourceIds: number[];
  timeZoneKeyName: string;
  isAllDayMeeting: boolean;
}

export class GetSuggestTimeInfo {
  readonly id: string;
  startTime: string;
  endTime: string;
  availabilityPercentage: number;
  availableCount: number;
  totalCount: number;
  unavailableAttendees: string[];
  isWithinWorkingHours: boolean;
  isAllDaySlot: boolean;
  isSelectedSlot: boolean;

  constructor(data?: Partial<GetSuggestTimeInfo>) {
    this.id = `${data?.startTime}-${data?.endTime}`;
    this.startTime = data?.startTime ?? "";
    this.endTime = data?.endTime ?? "";
    this.availabilityPercentage = data?.availabilityPercentage ?? 0;
    this.availableCount = data?.availableCount ?? 0;
    this.totalCount = data?.totalCount ?? 0;
    this.unavailableAttendees = data?.unavailableAttendees ?? [];
    this.isWithinWorkingHours = data?.isWithinWorkingHours ?? false;
    this.isAllDaySlot = data?.isAllDaySlot ?? false;
    this.isSelectedSlot = data?.isSelectedSlot ?? false;
  }
}

export class GetSuggestTimeResponse {
  suggestedSlots: GetSuggestTimeInfo[];

  constructor(data?: Partial<GetSuggestTimeResponse>) {
    this.suggestedSlots = (data?.suggestedSlots || []).map((item) => new GetSuggestTimeInfo(item));
  }
}
